<template>
    <div v-if="active" class="card">
        <div class="card-body">
            <PageHeader :title="screenData.text.cardTitle" variant="small" class="mb-4" />
            <BroadcastMessage v-for="(message, index) in messages" :message="message" :is-first="index === 0"
                              :do-not-show="screenData.text.doNotShow" @add-message="addMessage"
                              @remove-message="removeMessage">
            </BroadcastMessage>
            <ActionList :actions="screenData.actions" @broadcast-continue="sendList"></ActionList>
        </div>
    </div>
</template>

<script>
    import BroadcastMessage from '../entities/BroadcastMessage.vue';
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';

    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';

    export default {
        name: "BroadcastMessages",

        components: {
            BroadcastMessage,
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        props: {
            screenData: Object
        },

        data: function() {
            return {
                active: false,
                messages: [],
                optOutList: []
            }
        },

        methods: {
            show: function(data) {
                this.messages = data.data[0].messageList;
                this.action = data.action;
                this.hasMoreWork = data.hasMoreWork;
                this.active = true;
            },

            hide: function() {
                this.active = false;
            },

            addMessage: function(id) {
                this.optOutList.push({messageId: id});
            },

            removeMessage: function(id) {
                var index = -1;

                this.optOutList.forEach(function(k, v) {
                    if (k.messageId === id) {
                        index = v; 
                    }
                });

                if (index > -1) {
                    this.optOutList.splice(index, 1);
                }
            },

            sendList: function() {
                this.$emitter.emit('start-loading','broadcast-continue');
                var data = {
                    inboxMessage: this.optOutList
                };
                this.continue(data);
            }
        }
    }
</script>